

import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';

const providersKeys = {
  all: [ 'providers' ] as const,
  list: [ 'providers', 'list' ] as const
};

export function useProvidersQuery( opts: { enabled: boolean } ) {
  return useQuery( {
    queryKey: providersKeys.list,
    queryFn: async() => {
      const providers = await APIGateway.models.getProviders();
      return providers;
    },
    enabled: opts.enabled
  } );
}
